// Privacy Policy 页面组件 - 简洁白色样式
import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation()
  
  return (
    <div className="min-h-screen bg-white py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* 头部导航 */}
        <div className="mb-8">
          <Link 
            to="/register" 
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            {t('privacyPolicy.backToRegister')}
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">{t('privacyPolicy.title')}</h1>
          <p className="text-gray-600 mt-2">
            {t('privacyPolicy.lastUpdated')}: {new Date().toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>

        {/* 内容 */}
        <div className="prose max-w-none">
          <div className="space-y-8 text-gray-800">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('privacyPolicy.informationWeCollect.title')}</h2>
              <p className="mb-3">{t('privacyPolicy.informationWeCollect.intro')}</p>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li><strong>{t('privacyPolicy.informationWeCollect.accountInfo.title')}:</strong> {t('privacyPolicy.informationWeCollect.accountInfo.content')}</li>
                <li><strong>{t('privacyPolicy.informationWeCollect.usageData.title')}:</strong> {t('privacyPolicy.informationWeCollect.usageData.content')}</li>
                <li><strong>{t('privacyPolicy.informationWeCollect.paymentInfo.title')}:</strong> {t('privacyPolicy.informationWeCollect.paymentInfo.content')}</li>
                <li><strong>{t('privacyPolicy.informationWeCollect.technicalData.title')}:</strong> {t('privacyPolicy.informationWeCollect.technicalData.content')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('privacyPolicy.howWeUseInfo.title')}</h2>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li>{t('privacyPolicy.howWeUseInfo.item1')}</li>
                <li>{t('privacyPolicy.howWeUseInfo.item2')}</li>
                <li>{t('privacyPolicy.howWeUseInfo.item3')}</li>
                <li>{t('privacyPolicy.howWeUseInfo.item4')}</li>
                <li>{t('privacyPolicy.howWeUseInfo.item5')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('privacyPolicy.dataSharing.title')}</h2>
              <p className="mb-3">{t('privacyPolicy.dataSharing.intro')}</p>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li><strong>{t('privacyPolicy.dataSharing.thirdParty.title')}:</strong> {t('privacyPolicy.dataSharing.thirdParty.content')}</li>
                <li><strong>{t('privacyPolicy.dataSharing.legal.title')}:</strong> {t('privacyPolicy.dataSharing.legal.content')}</li>
                <li><strong>{t('privacyPolicy.dataSharing.business.title')}:</strong> {t('privacyPolicy.dataSharing.business.content')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('privacyPolicy.dataSecurity.title')}</h2>
              <p className="mb-4">
                {t('privacyPolicy.dataSecurity.content')}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('privacyPolicy.yourRights.title')}</h2>
              <p className="mb-3">{t('privacyPolicy.yourRights.intro')}</p>
              <ul className="list-disc list-inside space-y-2 mb-4">
                <li>{t('privacyPolicy.yourRights.item1')}</li>
                <li>{t('privacyPolicy.yourRights.item2')}</li>
                <li>{t('privacyPolicy.yourRights.item3')}</li>
                <li>{t('privacyPolicy.yourRights.item4')}</li>
                <li>{t('privacyPolicy.yourRights.item5')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('privacyPolicy.dataRetention.title')}</h2>
              <p className="mb-4">
                {t('privacyPolicy.dataRetention.content')}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('privacyPolicy.internationalTransfers.title')}</h2>
              <p className="mb-4">
                {t('privacyPolicy.internationalTransfers.content')}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">{t('privacyPolicy.contactUs.title')}</h2>
              <p className="mb-4">
                {t('privacyPolicy.contactUs.content')}
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy